import React from 'react';
import Select, { components } from 'react-select';

export const GetStartedSection = (props) => {
    const {
        getStartedSection,
        isShowRegions,
        regions,
        setRegion,
        labels,
    } = props;

    return (
        <div className="get-started-wrapper">
            {
                getStartedSection && getStartedSection['left_column']
                    ? (
                        <div className="get-started-wrapper__column">
                            <div dangerouslySetInnerHTML={{ __html: getStartedSection.left_column }} />

                            {
                                isShowRegions && regions && regions.length > 0 ? (
                                    <RegionSelect regions={regions} setRegion={setRegion} labels={labels} />
                                ) : null
                            }
                        </div>
                    ) : null
            }

            {
                getStartedSection['left_column'] && getStartedSection['right_column'] ? <span className="get-started-wrapper__divider" /> : null
            }

            {
                getStartedSection && getStartedSection['right_column']
                    ? (
                        <div className="get-started-wrapper__column">
                            <div dangerouslySetInnerHTML={{ __html: getStartedSection.right_column }} />
                            {
                                !getStartedSection['left_column'] && isShowRegions && regions && regions.length > 0
                                    ? (<RegionSelect regions={regions} setRegion={setRegion} labels={labels} />)
                                    : null
                            }
                        </div>
                    ) : null
            }
        </div>
    );
};

const RegionSelect = (props) => {
    const {
        regions,
        setRegion,
        labels,
    } = props;

    return (
        <label
            className="regions-selectbox get-started-wrapper__selectbox"
            htmlFor="regions-selectbox"
        >
            <span className="regions-selectbox__label">{labels?.regions_select_title || 'Select your state or territory:'}</span>
            <Select
                className="regions-selectbox__select"
                classNamePrefix="selectbox"
                defaultValue={{ value: regions[0].id, label: regions[0].name }}
                options={regions.map((region) => ({ value: region.id, label: region.name }))}
                onChange={(option) => setRegion(option.value)}
                inputId="regions-selectbox"
                placeholder={labels?.regions_select_title || 'Select your state or territory:'}
                isSearchable={false}
                components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                }}
                styles={{
                    menuList: (styles) => ({
                        ...styles,
                        padding: 0,
                        boxShadow: '0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03)',
                    }),
                    option: (styles, { isSelected, isFocused }) => ({
                        ...styles,
                        fontSize: 16,
                        lineHeight: '24px',
                        fontWeight: 500,
                        color: '#101828',
                        padding: '10px 14px',
                        backgroundColor: isSelected
                            ? '#d0d5dd'
                            : isFocused ? '#eef2fa' : 'transparent',
                    }),
                    control: (styles) => ({
                        ...styles,
                        minHeight: 44,
                        borderColor: '#D0D5DD',
                    }),
                    indicatorsContainer: (styles) => ({
                        ...styles,
                        paddingRight: 11,
                    }),
                    valueContainer: (styles) => ({
                        ...styles,
                        alignItems: 'center',
                        display: 'flex',

                        '::before': {
                            content: '""',
                            display: 'block',
                            marginLeft: 6,
                            marginRight: 10,
                            width: 18,
                            height: 22,
                            background: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='22' viewBox='0 0 18 22' fill='none'><path d='M8.99998 20.5999C8.99998 20.5999 16.513 13.9216 16.513 8.91294C16.513 4.76361 13.1493 1.3999 8.99998 1.3999C4.85064 1.3999 1.48694 4.76361 1.48694 8.91294C1.48694 13.9216 8.99998 20.5999 8.99998 20.5999Z' stroke='%23667085' stroke-width='2'/><path d='M11.4003 8.60005C11.4003 9.92554 10.3258 11.0001 9.00029 11.0001C7.67481 11.0001 6.60029 9.92554 6.60029 8.60005C6.60029 7.27457 7.67481 6.20005 9.00029 6.20005C10.3258 6.20005 11.4003 7.27457 11.4003 8.60005Z' stroke='%23667085' stroke-width='2'/></svg>") no-repeat center / contain`
                        },
                    }),
                    dropdownIndicator: (styles, state) => ({
                        ...styles,
                        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
                    }),
                    singleValue: (styles) => ({
                        ...styles,
                        fontWeight: 500,
                        lineHeight: '24px',
                    }),
                }}
                openMenuOnFocus
            />
        </label>
    )
}

const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#667085" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </components.DropdownIndicator>
        )
    )
};
